import { NextSeo } from "next-seo";
import { useUser } from "~/modules/user/hooks/useUser";
import { RedirectToLoginWhenNotAuthenticated } from "~/modules/auth/components/RedirectToLoginWhenNotAuthenticated";
import { FeatureFlag } from "~/modules/feature_flag/components/FeatureFlag";
import { FeatureNames } from "~/modules/feature_flag/flags";
import { Navbar } from "~/components/Navbar/component";
import { Routes } from "~/routes";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { PageWrapper, SidebarLayout } from "~/components/SidebarLayout";
import { PageHeader } from "~/components/PageHeader";
import { ApiKeysPageLayout } from "~/modules/api_keys/pages/list";
import { ApiToolsNav } from "~/modules/api_tools/components/ApiToolsNav";
import { Breadcrumbs } from "~/components/Breadcrumbs";

// // // //

export default function ApiTools() {
    const { user } = useUser();
    return (
        <RedirectToLoginWhenNotAuthenticated>
            <PageTrack route={Routes.apiToolsApiKeys}>
                <NextSeo title="API Keys" />

                <Navbar route={Routes.apiToolsApiKeys} user={user} />
                <FeatureFlag
                    feature={FeatureNames.enableApiKeys}
                    redirect={Routes.home}
                >
                    <SidebarLayout pathname={Routes.apiToolsApiKeys}>
                        <Breadcrumbs
                            pages={[
                                {
                                    name: "API Tools",
                                    href: Routes.apiTools,
                                },
                                {
                                    name: "API Keys",
                                    current: true,
                                },
                            ]}
                        />
                        <PageWrapper>
                            <PageHeader
                                title="API Tools"
                                // subtitle="Manage API keys for services built around RWA.xyz APIs"
                            />

                            <ApiToolsNav page="api-keys">
                                <ApiKeysPageLayout user={user} />
                            </ApiToolsNav>
                        </PageWrapper>
                    </SidebarLayout>
                </FeatureFlag>
            </PageTrack>
        </RedirectToLoginWhenNotAuthenticated>
    );
}
